function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8576 16.9904L18.409 20.7764C18.429 20.9274 18.4173 21.081 18.3748 21.227C18.3324 21.3731 18.26 21.5084 18.1625 21.6239C18.065 21.7395 17.9446 21.8328 17.8092 21.8976C17.6738 21.9624 17.5265 21.9973 17.3769 22H11.6371C11.4868 21.9996 11.3383 21.9663 11.2017 21.9022C11.0652 21.8382 10.9439 21.7449 10.8459 21.6288C10.748 21.5127 10.6757 21.3764 10.6342 21.2293C10.5926 21.0823 10.5827 20.9278 10.605 20.7764L11.1422 16.9904",
  stroke: "#3C445A",
  strokeWidth: 0.75,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4449 7H8.55514C7.69626 7 7 7.70895 7 8.58349V15.4357C7 16.3102 7.69626 17.0192 8.55514 17.0192H20.4449C21.3037 17.0192 22 16.3102 22 15.4357V8.58349C22 7.70895 21.3037 7 20.4449 7Z",
  stroke: "#3C445A",
  strokeWidth: 0.75,
  strokeLinejoin: "round"
});

var SvgKasse = function SvgKasse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKasse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kasse.92e2cebd.svg";
export { ForwardRef as ReactComponent };